<template>
  <div class="content-center">
    <div class="banner">
      <div class="content">
        <div class="title">汇通数科生态伙伴计划</div>
        <div class="desc">
          携手合作伙伴联合创新，不断深耕产品和服务，共同打造面向产业互联网的场景化SaaS解决方案，降低企业数字化转型的成本，持续为客户和伙伴创造价值！
        </div>
        <div class="btn-wrap">
          <div class="btn" @click="goAnchor('#join')">立即加入</div>
        </div>
      </div>
    </div>
    <div class="partner">
      <div class="sk-block-title">
        <div class="title">为合作伙伴赋能，与合作伙伴共同成长</div>
      </div>
      <div class="content">
        <div class="item">
          <img src="@/assets/images/cooperate/ecoPartner_partner1.png" alt="">
          <span>服务支持</span>
          <p>
            一对一客服，7*12技术服务响应，客户成功团队即时在线答疑、远程指导，提供定期渠道交流会等一整套服务支持
          </p>
        </div>
        <div class="item">
          <img src="@/assets/images/cooperate/ecoPartner_partner2.png" alt="">
          <span>市场营销</span>
          <p>
            资源共享互通，联合开展市场营销活动、技术沙龙分享会、研讨会、行业展会等
          </p>
        </div>
        <div class="item">
          <img src="@/assets/images/cooperate/ecoPartner_partner3.png" alt="">
          <span>技术支持</span>
          <p>
            快速响应客户与合作伙伴需求，拥有200人强大的研发团队，并持续加大产品研发投入，保持产品领先
          </p>
        </div>
        <div class="item">
          <img src="@/assets/images/cooperate/ecoPartner_partner4.png" alt="">
          <span>生态共赢</span>
          <p>
            开放、协同、共赢的生态体系，帮助合作伙伴快速融入生态圈，匹配最佳资源，互利共赢，引领合作新模式
          </p>
        </div>
      </div>
    </div>
    <div class="process">
      <div class="sk-block-title">
        <div class="title">合作流程</div>
      </div>
      <div class="content">
        <img src="@/assets/images/cooperate/ecoPartner_process.png" alt="">
      </div>
    </div>
    <div class="win">
      <div class="sk-block-title">
        <div class="title">成人达己  互利共赢</div>
      </div>
      <div class="content">
        <img src="@/assets/images/cooperate/ecoPartner_all-win.png" alt="">
      </div>
    </div>
    <div class="ecoSystem">
      <div class="sk-block-title">
        <div class="title">携手合作伙伴共同打造生态系统</div>
      </div>
      <div class="content">
        <img src="@/assets/images/cooperate/ecoPartner_ecosystem.png" alt="">
      </div>
    </div>
    <div id="join" class="join">
      <div class="title">合作伙伴 期待您的加入</div>
      <a-form :form="form" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }" colon hide-required-mark class="form" @submit="handleSubmit">
        <div class="formItem">
          <a-form-item label="公司名称">
            <a-input
              v-decorator="['company', { rules: [{ required: true, message: '请输入公司名称!' }] }]"
              placeholder="必填，公司名称与营业执照一致"
            />
          </a-form-item>
        </div>
        <a-form-item label="联系人">
          <a-input
            v-decorator="['name', { rules: [{ required: true, message: '请输入联系人姓名!' }] }]"
            placeholder="必填，联系人姓名"
          />
        </a-form-item>
        <a-form-item label="联系电话" :validate-status="userError() ? 'error' : ''" :help="userError() || ''">
          <a-row :gutter="20">
            <a-col :span="12">
              <a-input
                v-decorator="['phone', { rules: [{
                  required: true,
                  message: '请输入手机号!'
                }, {
                  validator: checktelphone,
                }] }]"
                placeholder="必填，联系人电话"
              />
            </a-col>
            <a-col :span="12">
              <a-input-search
                v-decorator="['verifyCode', { rules: [{ required: true, message: '请输入短信验证码!' }] }]"
                placeholder="短信验证码"
                size="large"
                @search="getVerificationCode"
              >
                <a-button slot="enterButton" :disabled="!isShowGetCode">
                  <template v-if="isShowGetCode">获取验证码</template>
                  <template v-else>{{ countdown }}s后可重试</template>
                </a-button>
              </a-input-search>
            </a-col>
          </a-row>
        </a-form-item>
        <a-form-item label="所在城市">
          <a-input
            v-decorator="[
              'address',
              { rules: [{ required: true, message: '请输入所在城市!' }] },
            ]"
            placeholder="请输入所在城市"
          />
        </a-form-item>
        <a-form-item label="目前行业">
          <a-input
            v-decorator="[
              'industry',
              { rules: [{ required: true, message: '请输入行业!' }] },
            ]"
            placeholder="请输入行业"
          />
        </a-form-item>
        <a-form-item label="合作意向">
          <a-input
            v-decorator="['informationExplain']"
            :style="{
              height: '100px'
            }"
            type="textarea"
            placeholder="请将您的合作需求或建议反馈给我们"
          />
        </a-form-item>
        <a-form-item :wrapper-col="{ span: 12, offset: 8 }">
          <a-button type="primary" html-type="submit" class="submit-btn">
            合作加盟
          </a-button>
        </a-form-item>
      </a-form>
      <div id="captcha" />
    </div>
  </div>
</template>

<script>
import metaInfo from '@/common/util/metaInfo'
import { sendSmsCaptcha, informationCollection } from '@/apis/index'
export default {
  metaInfo: metaInfo.EcoPartner,
  data() {
    return {
      form: this.$form.createForm(this),
      captcha: null,
      countdown: 60,
      timer: '',
      isShowGetCode: true,
      captchaIns: null,
      params: null
    }
  },
  mounted() {
    this.getCode()
  },
  methods: {
    userError() {
      const { getFieldError } = this.form
      return getFieldError('phone') || getFieldError('verifyCode')
    },
    checktelphone(rule, value, callback) {
      const reg = /^1[3456789]\d{9}$/
      if (value && !(reg.test(value))) {
        callback('请输入正确的手机号码！')
      } else {
        callback()
      }
    },
    // 模拟锚点跳转
    goAnchor(selector) { // 参数selector是id选择器（#anchor14）
      document.querySelector(selector).scrollIntoView({
        behavior: 'smooth'
      })
    },
    getVerificationCode() {
      this.form.validateFields(['imgCaptcha', 'phone'], (errors, values) => {
        if (!errors) {
          this.params = values
          this.captchaIns.popUp()
        }
      })
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          const params = {
            infoSources: '汇通数科官网-生态伙伴',
            officialWebsiteEntrance: 'PC',
            address: values.address,
            name: values.name,
            phone: values.phone,
            verifyCode: values.verifyCode,
            company: values.company,
            industry: values.industry,
            informationExplain: values.informationExplain
          }
          informationCollection(params).then(res => {
            this.$message.success({
              content: '感谢您的信息提交，我们将会有专员与您联系~',
              duration: 1
            })
            this.captchaIns.refresh()
            this.form.resetFields()
          }).catch(err => {
            this.$message.error(err)
            this.captchaIns.refresh()
          })
        }
      })
    },
    countDown() {
      const self = this
      this.timer = setInterval(() => {
        self.countdown--
        if (self.countdown === 0) {
          clearInterval(self.timer)
          self.countdown = 60
          self.isShowGetCode = true
          self.captchaIns.refresh()
        }
      }, 1000)
    },
    getCode() {
      const that = this
      // eslint-disable-next-line no-undef
      initNECaptcha && initNECaptcha({
        element: '#captcha',
        captchaId: '6c0483e901164a789d9d13f0291ba257',
        mode: 'popup',
        width: '320px',
        // enableClose: true,
        onClose: function() {
          // 弹出关闭结束后将会触发该函数
        },
        onVerify: function(err, data) {
          if (err) return
          // that.captchaIns.close()
          that.params.pictureCode = data.validate
          sendSmsCaptcha(that.params).then(data => {
            that.countDown()
            that.isShowGetCode = false
          }).catch(err => {
            that.$message.error(err)
            that.captchaIns.refresh()
          })
        }
      }, function(instance) {
        // 初始化成功后得到验证实例instance，可以调用实例的方法
        that.captchaIns = instance
      }, function(err) {
        console.log(err)
        // 初始化失败后触发该函数，err对象描述当前错误信息
      })
    }
  }
}
</script>

<style lang="less" scoped>
  .banner {
    background: url("~@/assets/images/cooperate/ecoPartner_banner.png") no-repeat center;
    background-size: 100% 100%;
    min-width: 1200px;
    .content {
      width: 1200px;
      margin: 0 auto;
      padding: 80px 0 95px;
      .title {
        font-size: 48px;
        color: #FFFFFF;
        line-height: 46px;
        text-shadow: 0px 2px 4px rgba(14, 15, 120, 0.17);
      }
      .desc {
        width: 930px;
        height: 73px;
        margin: 0 auto;
        font-size: 22px;
        color: #FFFFFF;
        line-height: 28px;
        text-shadow: 0px 2px 4px rgba(15, 23, 135, 0.29);
        padding-top: 40px;
      }
      .btn-wrap {
        margin-top: 36px;
        .btn {
          width: 234px;
          height: 48px;
          line-height: 48px;
          margin: 0 auto;
          border-radius: 6px;
          border: 1px solid #FFFFFF;
          font-size: 22px;
          font-weight: 400;
          color: #FFFFFF;
          cursor: pointer;
        }
      }
    }
  }
  .partner {
    margin-bottom: 20px;
    .content {
      display: flex;
      width: 1200px;
      margin: 79px auto 0;
      .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 300px;
        span {
          padding-top: 50px;
          font-weight: 500;
          font-size: 20px;
          color: #595961;
          line-height: 28px;
        }
        p {
          width: 238px;
          padding-top: 20px;
          font-size: 14px;
          font-weight: 400;
          color: #595961;
          line-height: 24px;
        }
      }
    }
  }
  .process {
    width: 1180px;
    margin: 0 auto;
    padding-bottom: 77px;
    .content {
      margin-top: 48px;
    }
  }
  .win {
    background: #fafafa;
    .content {
      margin-top: 43px;
      padding-bottom: 97px;
    }
  }
  .ecoSystem {
    padding-bottom: 119px;
    .content {
      img {
        display: block;
        width: 1170px;
        margin: 47px auto 0;
      }
    }
  }
  .join {
    height: 782px;
    overflow: hidden;
    padding: 58px 0 66px;
    background: url("~@/assets/images/cooperate/ecoPartner_form-bg.png") no-repeat;
    .title {
      font-size: 36px;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 50px;
    }
    .form {
      width: 800px;
      margin: 60px auto 0;
      font-size: 18px;
      transform: translateX(-61px);
      .label {
        font-size: 20px;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 28px;
        text-align: right;
        padding: 5px 7px 5px;
      }
      /deep/ .ant-input  {
        height: 50px;
        font-size: 20px;
      }
      /deep/ .ant-btn-lg {
        height: 50px;
        font-size: 20px;
        color: #FF7700;
        background: #F9FBFD;
      }
      /deep/ .ant-select-selection--single {
        height: 50px;
      }

      /deep/ .ant-select-selection__rendered {
        line-height: 50px;
        font-size: 20px;
      }
      /deep/ .ant-form-item-label {
        line-height: 50px;
      }
      /deep/ .ant-form-item-label > label {
        color: #fff;
        font-size: 20px;
      }
      /deep/ .ant-btn{
        height: 50px;
      }
      .submit-btn {
        width: 400px;
        height: 50px;
        background: #FF8C24;
        border-radius: 35px;
        font-size: 20px;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 40px;
      }
      .imgCaptcha {
        display: inline-block;
        margin: 0;
        height: 50px;
        margin-left: 10px;
      }
      .reload {
        color: #FF7700;
        font-size: 18px;
        cursor: pointer;
        line-height: 50px;
        margin-left: 20px;
      }
      .captcha-wapper {
        background-color: #fff;
        border-radius: 4px;
        display: flex;
        justify-content: space-around;
      }
    }
  }
</style>
